export default __webpack_public_path__ + "static/media/Home-Page-Background.f7e4d8f1.jpg";